// extracted by mini-css-extract-plugin
export default {"link":"style--link--23997e","icon":"style--icon--fa6d3b"};